import { observable, action } from 'mobx';
import orderAdapter from 'adapters/OrderAdapter';

const VIEW_TYPE_MAP = {
  'ord-disp-rfq': 'rfq',
  'ord-disp-auc': 'auc',
  'ord-disp-clob': 'clob',
  'ord-disp-voice': 'voice',
  'trade-disp': 'tradeDisplay',
  'trade-disp-2': 'individual'
};

class OrderStore {
  @observable orderDataLoadInProgress = false;
  @observable viewId = null;
  @observable order = null;

  loadData(criteria) {
    this.orderDataLoadInProgress = true;

    const onDataLoaded = action((response) => {
      this.orderDataLoadInProgress = false;
      return response;
    });

    const self = this;

    return orderAdapter.loadData(criteria).then((data) => {
      self.order = data;
      self.viewId = VIEW_TYPE_MAP[data.viewType] || 'unknown';
      onDataLoaded();

      return data;
    }, onDataLoaded);
  }
}

export default new OrderStore();



// WEBPACK FOOTER //
// ./src/stores/OrderStore.js